(() => {
  const backgroundObservers = new WeakMap();
  const bind = (root) => {
    if (root.dataset.standardsBound) return;
    root.dataset.standardsBound = 'true';
    const background = root.querySelector('[data-standards-earth]');
    if (background) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        backgroundObservers.delete(root);
        const picture = background.content.cloneNode(true);
        picture.querySelector('img').loading = 'eager';
        background.replaceWith(picture);
      }, {
        root: matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null,
        rootMargin: '1000px 0px'
      });
      backgroundObservers.set(root, observer);
      observer.observe(root);
    }

    const cards = [...root.querySelectorAll('.absen-standard')];
    const setOpen = (card, open) => {
      card.setAttribute('aria-expanded', String(open));
      card.setAttribute('aria-describedby', open ? card.getAttribute('aria-controls') : card.querySelector('.absen-standard__summary').id);
      card.querySelector('.absen-standard__front').setAttribute('aria-hidden', String(open));
      card.querySelector('.absen-standard__back').setAttribute('aria-hidden', String(!open));
    };
    cards.forEach((card) => {
      card.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') setOpen(card, card.getAttribute('aria-expanded') !== 'true');
      });
      card.addEventListener('click', (event) => {
        const toggle = event.pointerType === 'touch' || event.detail === 0;
        if (toggle && card.getAttribute('aria-expanded') === 'true') setOpen(card, false);
        else setOpen(card, true);
      });
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setOpen(card, false);
      });
    });
    root.querySelector('[data-standards-chat]')?.addEventListener('click', (event) => {
      const launcher = document.querySelector('#absen-chat-launcher');
      if (launcher) {
        event.preventDefault();
        launcher.click();
      }
    });
  };
  document.querySelectorAll('.absen-standards').forEach(bind);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.absen-standards').forEach(root => {
      backgroundObservers.get(root)?.disconnect();
      backgroundObservers.delete(root);
    });
  });
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.absen-standards').forEach(bind);
  });
})();
